import {
  collectionTypeToStudentType,
  studentTypeToCollectionType,
} from '@/helpers/collectionTypes';
import type { StudentCollectionType } from '@/helpers/collectionTypes';
import type { StudentType } from '@/types/students';

export const PERIOD_PANELS = ['organizations', 'periods'] as const;

export type PeriodPanel = (typeof PERIOD_PANELS)[number];

export interface PeriodPageSearch {
  category?: StudentType;
  panel?: PeriodPanel;
}

const isStudentType = (value: unknown): value is StudentType =>
  value === 'travels' ||
  value === 'transportation' ||
  value === 'child-and-youth';

const isPeriodPanel = (value: unknown): value is PeriodPanel =>
  value === 'organizations' || value === 'periods';

export const parsePeriodPageSearch = (
  search: Record<string, unknown>,
): PeriodPageSearch => ({
  category: isStudentType(search.category) ? search.category : undefined,
  panel: isPeriodPanel(search.panel) ? search.panel : undefined,
});

export const collectionTypeFromPeriodSearch = (
  search: PeriodPageSearch,
  defaultCategory: StudentCollectionType,
): StudentCollectionType =>
  search.category
    ? studentTypeToCollectionType(search.category)
    : defaultCategory;

export const panelFromPeriodSearch = (search: PeriodPageSearch): PeriodPanel =>
  search.panel ?? 'organizations';

export const buildPeriodPageSearch = (
  collectionType: StudentCollectionType,
  panel: PeriodPanel,
  defaultCategory: StudentCollectionType,
): PeriodPageSearch => ({
  ...(collectionType === defaultCategory
    ? {}
    : { category: collectionTypeToStudentType(collectionType) }),
  ...(panel === 'organizations' ? {} : { panel }),
});
